import { Box, Collapse, Flex, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react'
import { format } from 'date-fns'
import React from 'react'

export const TotalDeNegociacoes = ({ negociacao_atual, verMais, setVerMais, historico_negociacoes }) => {
  // Garantir que negociacao_ atual existe antes de acessar propriedades
  const total = negociacao_atual?.total_negociacao || 0

  const [historico, setHistorico] = React.useState(historico_negociacoes?.slice(0, 1) || [])

  const handleVerMais = () => {
    setVerMais(!verMais)
    if (verMais) {
      setHistorico(historico_negociacoes?.slice(0, 1) || [])
    } else {
      setHistorico(historico_negociacoes || [])
    }
  }

  return (
    <Flex fontSize="12px" py={4} flexDir="column" border="1px solid #CFCFCF">
      <Text fontWeight="semibold" textTransform="uppercase" color="#378BBF" px={2} pb={4}>
        Total de negociações:
        <Text as="span" color="black">
          {' '}
          {total}
        </Text>
      </Text>

      <Collapse
        in={verMais}
        animateOpacity
        style={{
          position: 'absolute',
          bottom: '100%',
          left: 0,
          width: '100%',
          zIndex: 10,
        }}
      >
        <Box bg="white" boxShadow="lg" borderRadius="md" p={1}>
          <TableContainer
            maxH="450px"
            overflowY="auto"
            sx={{
              '&::-webkit-scrollbar': { width: '4px', height: '4px' },
              '&::-webkit-scrollbar-thumb': { backgroundColor: '#378BBF', borderRadius: '24px' },
              '&::-webkit-scrollbar-track': { backgroundColor: '#F1F1F1' },
            }}
          >
            <Table fontSize="12px" size="sm" variant="simple">
              <Thead>
                <Tr>
                  <Th bgColor="#378BBF" color="white" px={2} fontSize="12px">
                    DATA
                  </Th>
                  <Th bgColor="#378BBF" color="white" px={2} fontSize="12px">
                    VALOR UN.
                  </Th>
                  <Th bgColor="#378BBF" color="white" px={2} fontSize="12px">
                    % COMISSÃO
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {historico?.map((item, index) => (
                  <Tr key={index}>
                    <Td px={2} fontSize="12px">
                      <strong>{format(new Date(item.data_negociacao), 'dd/MM/yyyy')}</strong>
                    </Td>
                    <Td px={2} fontSize="12px">
                      <strong>R$ {item.valor_unitario}</strong>
                    </Td>
                    <Td px={2} fontSize="12px">
                      <strong>{item.comissao} %</strong>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      </Collapse>

      {historico_negociacoes?.length > 0 && (
        <Flex
          justifyContent="center"
          py={2}
          bgColor="#378BBF"
          color="white"
          cursor="pointer"
          onClick={handleVerMais}
          fontSize="12px"
          transition="all 0.3s ease-in-out"
        >
          {verMais ? 'Ver menos' : 'Ver mais'}
        </Flex>
      )}
    </Flex>
  )
}
